import type { App } from '../app/App';
import { HowToPlayPopup } from '../game/views/popups/HowToPlayPopup';
import { GAME_ECONOMY_SETTINGS } from '../game/GameConstants';

export function openHowToPlayPopup(app: App): void {
  const {
    controller: { popups },
    stateController,
  } = app;

  const popup = new HowToPlayPopup({
    boostersDefinitions: GAME_ECONOMY_SETTINGS.boosters,
    levelNumber: stateController.getLevelNumber(),
  });

  popup.onCloseClicked.connect(() => {
    void popups.closeActivePopup();
  });

  void popups.addPopup({
    popupInstance: popup,
    settings: { overlay: false, hideRays: true },
  });
}
